import React, { FunctionComponent } from "react";
import { ModelStyle } from "@iventis/domain-model/model/modelStyle";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { createStaticStyleValue } from "@iventis/layer-style-helpers";
import { incrementalValueSelectorComponentCreator } from "@iventis/components";
import { Content } from "@iventis/translations";
import { EditStyleItemComponent } from "./edit-style-item";
import { EditStyleProps } from "./style.types";
import BaseModelEditStyleComponent from "./base-model-edit-style";

export const ModelEditStyleComponent: FunctionComponent<EditStyleProps<ModelStyle>> = ({ layerStyle, changeStyleValue, dataFields }) => {
    const translate = useIventisTranslate();
    return (
        <BaseModelEditStyleComponent layerStyle={layerStyle} dataFields={dataFields} changeStyleValue={changeStyleValue}>
            <EditStyleItemComponent
                styleProperty="modelAltitude"
                value={layerStyle.modelAltitude ?? createStaticStyleValue(0)}
                changeStyleValue={changeStyleValue}
                component={incrementalValueSelectorComponentCreator({
                    minValue: 0,
                    maxValue: 50,
                    increment: 1,
                    decimals: 2,
                    units: [{ id: "meters", name: "meters" }],
                    selectedUnitId: "meters",
                    testId: "model-altitude",
                })}
                title={translate(Content.map10.style.altitude)}
                isZoomableValue={false}
            />
        </BaseModelEditStyleComponent>
    );
};
